export function sendElemtnClicked(
	elementType,
	location,
	name,
	position,
	text,
	actionOutcome,
	outboundUrl
) {
	tagular('beam', {
		'@type': 'redventures.usertracking.v3.ElementClicked',
		webElement: {
			elementType,
			location,
			name,
			position,
			text,
		},
		actionOutcome,
		outboundUrl,
	});
}

export function trackFromEvents(formEvent, eventPayload) {
	tagular('beam', formEvent, {
		'@type': `redventures.usertracking.v3.${formEvent}`,
		...(eventPayload.field ? { field: eventPayload.field } : {}),
		formContext: {
			formType: eventPayload.formType,
			formName: eventPayload.formName,
			formId: eventPayload.formId,
		},
		captureContext: {
			captureType: eventPayload.captureType,
			capturePlacement: eventPayload.capturePlacement,
			valueProp: eventPayload.valueProp,
			identityRequested: true,
		},
	});
}

export function sendFormSubmitted(eventPayload) {
	trackFromEvents('FormSubmitted', eventPayload);
}

export function sendFormViewed(eventPayload) {
	trackFromEvents('FormViewed', eventPayload);
}
